import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const StreetIcon = memo((props) => {
  return (
    <SvgIcon
      viewBox="0 0 512.003 512.003"
      {...props}
      transform="translate(1, 0) scale(0.8, 0.8)"
    >
      <path
        d="M129.286,67.439c-4.713,0-8.533,3.82-8.533,8.533v32.913c0,4.713,3.82,8.533,8.533,8.533c4.713,0,8.533-3.82,8.533-8.533
				V75.972C137.819,71.259,133.998,67.439,129.286,67.439z"
      />
      <path
        d="M129.286,314.3c-4.713,0-8.533,3.82-8.533,8.533v32.913c0,4.713,3.82,8.533,8.533,8.533c4.713,0,8.533-3.821,8.533-8.533
				v-32.913C137.819,318.12,133.998,314.3,129.286,314.3z"
      />
      <path
        d="M129.286,232.013c-4.713,0-8.533,3.821-8.533,8.533v32.913c0,4.713,3.82,8.533,8.533,8.533
				c4.713,0,8.533-3.82,8.533-8.533v-32.913C137.819,235.833,133.998,232.013,129.286,232.013z"
      />
      <path
        d="M129.286,396.587c-4.713,0-8.533,3.82-8.533,8.533v32.913c0,4.713,3.82,8.533,8.533,8.533
				c4.713,0,8.533-3.82,8.533-8.533V405.12C137.819,400.407,133.998,396.587,129.286,396.587z"
      />
      <path
        d="M129.286,149.726c-4.713,0-8.533,3.821-8.533,8.533v32.913c0,4.713,3.82,8.533,8.533,8.533
				c4.713,0,8.533-3.82,8.533-8.533v-32.913C137.819,153.546,133.998,149.726,129.286,149.726z"
      />
      <path
        d="M362.292,156.993l-23.208,23.206c-3.333,3.332-3.333,8.735,0,12.068c3.332,3.333,8.735,3.333,12.068,0.001l23.208-23.206
				c3.333-3.332,3.333-8.735,0.001-12.068C371.027,153.661,365.624,153.661,362.292,156.993z"
      />
      <path
        d="M304.273,215.007l-23.208,23.206c-3.333,3.332-3.333,8.735-0.001,12.068s8.735,3.333,12.068,0.001l23.208-23.206
				c3.333-3.332,3.333-8.735,0.001-12.068C313.008,211.675,307.605,211.675,304.273,215.007z"
      />
      <path
        d="M246.253,273.032l-12.066,12.066c-3.332,3.333-3.332,8.736,0,12.068s8.735,3.332,12.068,0l12.066-12.066
				c3.332-3.332,3.332-8.735,0-12.068S249.585,269.7,246.253,273.032z"
      />
      <path
        d="M499.68,188.556L342.795,31.67c-3.333-3.333-8.736-3.332-12.068,0l-81.97,81.977V9.536c0-4.713-3.82-8.533-8.533-8.533
				H129.336c-0.017,0-0.034-0.003-0.051-0.003s-0.034,0.002-0.051,0.003H18.356c-4.713,0-8.533,3.82-8.533,8.533v494.933
				c0,4.713,3.82,8.533,8.533,8.533h221.867c4.713,0,8.533-3.821,8.533-8.533v-52.922L499.68,200.624
				C503.013,197.291,503.013,191.888,499.68,188.556z M234.189,441.979c-1.6,1.6-2.499,3.771-2.499,6.034v47.923h-93.871V487.4
				c0-4.713-3.82-8.533-8.533-8.533c-4.713,0-8.533,3.82-8.533,8.533v8.536H26.89V18.069h93.862V26.6
				c0,4.713,3.82,8.533,8.533,8.533c4.713,0,8.533-3.82,8.533-8.533v-8.531h93.871v116.181c0,7.603,9.192,11.41,14.568,6.034
				l90.504-90.512l66.375,66.375l-6.032,6.032c-3.332,3.333-3.332,8.735,0,12.068c3.332,3.332,8.736,3.332,12.068,0l6.032-6.032
				l66.374,66.374L234.189,441.979z"
      />
    </SvgIcon>
  );
});
